/**
 * Admin Dashboard Context.
 *
 * Provides the admin page state + actions to deeply-nested children
 * (UsersTabContent, modals, etc.) without prop drilling. Scoped to the
 * AdminDashboard tree only — auth and user identity still come from
 * the global AuthContext.
 *
 * Keep this lean: only put values here that are actually consumed by
 * 2+ child components. One-off state stays local in AdminDashboard.
 */
import React, { createContext, useContext } from 'react';

const AdminDashboardContext = createContext(null);

export function AdminDashboardProvider({ value, children }) {
  return (
    <AdminDashboardContext.Provider value={value}>
      {children}
    </AdminDashboardContext.Provider>
  );
}

export function useAdminDashboard() {
  const ctx = useContext(AdminDashboardContext);
  if (!ctx) {
    throw new Error('useAdminDashboard must be used inside <AdminDashboardProvider>');
  }
  return ctx;
}
